import {
    PictogramLocationSmall,
    PictogramMailSmall,
    PictogramPricesSmall,
    PictogramQuestionSmall,
    PictogramRefreshSmall,
    PictogramSaveSmall,
    PictogramSearchSmall,
    PictogramSettingsSmall,
    PictogramTimeSmall,
    PictogramUploadSmall,
    PictogramVillageSmall
} from '@zoopla-eng/zds-components/pictograms';

export const getPictogram = (pictogram: string) => {
    switch (pictogram) {
        case 'Prices':
        case 'Currency':
            return PictogramPricesSmall;
        case 'Email':
            return PictogramMailSmall;
        case 'Location':
            return PictogramLocationSmall;
        case 'Question':
            return PictogramQuestionSmall;
        case 'Refresh':
            return PictogramRefreshSmall;
        case 'Save':
            return PictogramSaveSmall;
        case 'Search':
            return PictogramSearchSmall;
        case 'Settings':
            return PictogramSettingsSmall;
        case 'Time':
            return PictogramTimeSmall;
        case 'Upload':
            return PictogramUploadSmall;
        case 'Village':
            return PictogramVillageSmall;
        default:
            return null;
    }
};
